export const ADMIN_LIST_SORT_VALUES = [
  'updated_at_desc',
  'created_at_desc',
  'updated_at_asc',
  'created_at_asc',
] as const;

export type AdminListSort = (typeof ADMIN_LIST_SORT_VALUES)[number];
export type AdminListSortField = 'created_at' | 'updated_at';
export type AdminListSortDirection = 'asc' | 'desc';

export const DEFAULT_ADMIN_LIST_SORT: AdminListSort = 'updated_at_desc';

export const ADMIN_LIST_SORT_OPTIONS: Array<{
  value: AdminListSort;
  label: string;
}> = [
  { value: 'updated_at_desc', label: 'Cập nhật gần nhất' },
  { value: 'created_at_desc', label: 'Tạo gần nhất' },
  { value: 'updated_at_asc', label: 'Cập nhật cũ nhất' },
  { value: 'created_at_asc', label: 'Tạo cũ nhất' },
];

export const isAdminListSort = (value: unknown): value is AdminListSort =>
  typeof value === 'string' && ADMIN_LIST_SORT_VALUES.includes(value as AdminListSort);

export const normalizeAdminListSort = (value: unknown): AdminListSort =>
  isAdminListSort(value) ? value : DEFAULT_ADMIN_LIST_SORT;

export const getAdminListSortCriteria = (value: unknown): {
  field: AdminListSortField;
  direction: AdminListSortDirection;
} => {
  const normalizedValue = normalizeAdminListSort(value);
  const direction = normalizedValue.endsWith('_asc') ? 'asc' : 'desc';
  const field = normalizedValue.startsWith('created_at') ? 'created_at' : 'updated_at';

  return { field, direction };
};
